import ibni_mockup from '../images/ibnii_mockup.png';
import image1 from '../images/Image1.png';
import image3 from '../images/Image3.png';
import image4 from '../images/Image4.png';
import image5 from '../images/Image5.png';
import image6 from '../images/Image6.jpg';
import image8 from '../images/Image8.jpeg';
import image9 from '../images/Image9.jpg';
import realign_healthcare from '../images/realign_healthcare.png';
import srpipl_mockup from '../images/srpipl_mockup.png';
import tranzanalytics_mockup from '../images/tranzanalytics_mockup.png';

export const categories = ['All', 'Web Development', 'Product Design', 'App Development'];

export const projects = [
    {
        background: 'linear-gradient(180deg, #D6DEE3 0%, #FFD6D2 100%)',
        categories: ['Web Development', 'Product Design'],
        fit: 'contain',
        id: 1,
        image: image1,
        padding: '0.8rem',
        title: 'Maurya Kushwaha Samaj, Community Site',
    },
    {
        background: 'linear-gradient(180deg, #D6DEE3 0%, #FFD6D2 100%)',
        categories: ['Web Development'],
        fit: 'contain',
        id: 3,
        image: image4,
        padding: '0.8rem',
        title: 'Maurya Kushwaha Samaj, Admin Application',
    },
    {
        background: 'linear-gradient(180deg, #44637D 0%, #4F535A 100%)',
        categories: ['App Development', 'Product Design'],
        fit: 'contain',
        id: 2,
        image: image5,
        padding: '0',
        title: 'StayInEase - Property & Tenant Management System',
    },
    {
        background: 'linear-gradient(180deg, #44637D 0%, #4F535A 100%)',
        categories: ['Product Design'],
        fit: 'cover',
        id: 6,
        image: image6,
        padding: '0s',
        title: 'TailDelights - Pet Products, Landing Site',
    },
    {
        background: 'linear-gradient(180deg, #D6DEE3 0%, #FFD6D2 100%)',
        categories: ['Web Development', 'Product Design'],
        fit: 'cover',
        id: 5,
        image: image3,
        padding: '0',
        title: 'Melding Minds - Psychiatrist Consultation App',
    },
    {
        background: 'linear-gradient(180deg, #D6DEE3 0%, #FFD6D2 100%)',
        categories: ['Product Design'],
        fit: 'cover',
        id: 4,
        image: image8,
        padding: '0',
        title: 'Saamay - Astrology Consultancy App',
    },
    {
        background: 'linear-gradient(180deg, #D6DEE3 0%, #FFD6D2 100%)',
        categories: ['Web Development', 'Product Design'],
        fit: 'cover',
        id: 7,
        image: image9,
        padding: '',
        title: 'Loomin Labs - Digital Branding & Web Innovation',
    },
    {
        background: 'linear-gradient(180deg, #D6DEE3 0%, #FFD6D2 100%)',
        categories: ['Web Development', 'Product Design'],
        fit: 'cover',
        id: 8,
        image: tranzanalytics_mockup,
        padding: '',
        title: 'Tranzanalytics - Empowering Data-Driven Decisions',
    },
    {
        background: 'linear-gradient(180deg, #D6DEE3 0%, #FFD6D2 100%)',
        categories: ['Web Development', 'Product Design'],
        fit: 'cover',
        id: 9,
        image: ibni_mockup,
        padding: '',
        title: 'IBNII - Your Nature-Retreat & Wellness Escape',
    },
    {
        background: 'linear-gradient(180deg, #D6DEE3 0%, #FFD6D2 100%)',
        categories: ['Web Development', 'Product Design'],
        fit: 'cover',
        id: 10,
        image: srpipl_mockup,
        padding: '',
        title: 'SRP Innovations - Crafting Sustainable Industrial Solutions',
    },
    {
        background: 'linear-gradient(180deg, #D6DEE3 0%, #FFD6D2 100%)',
        categories: ['Web Development', 'Product Design'],
        fit: 'cover',
        id: 11,
        image: realign_healthcare,
        padding: '',
        title: 'Realign Healthcare - Aligning You with Pain-Free Living',
    },
];
